import { Divider, DividerProps } from 'antd'

export interface KBDividerProps extends DividerProps {}

export function KBDivider(props: KBDividerProps) {
  return <Divider {...props}></Divider>
}
